import type { FC } from 'react';
import cn from 'classnames';
import { useMeasureElement } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElement';
import { StudioDeviationListContext } from '../../context';
import SortableDeviationList from '../SortableDeviationList';
import DeviationListItem from '../../items/DeviationListItem';
import { Props } from '../../StudioDeviationList';

import s from './DeviationList.scss';

const DeviationList: FC<Props> = ({ deviations, selectProps }) => {
  const { ref: tagsColRef, dimensions: tagsDimensions } = useMeasureElement({
    throttle: 250,
    throttleOptions: { trailing: true },
  });
  const { ref: actionsColRef, dimensions: actionsDimensions } = useMeasureElement({
    throttle: 250,
    throttleOptions: { trailing: true },
  });

  return (
    <StudioDeviationListContext.Provider
      value={{
        tagsColRef,
        tagsColWidth: tagsDimensions.width && Math.floor(tagsDimensions.width),
        actionsColRef,
        actionsColWidth: actionsDimensions.width && Math.floor(actionsDimensions.width),
      }}
    >
      <SortableDeviationList
        listClassName={s['list']}
        deviations={deviations}
        selectProps={selectProps}
        renderItem={({ deviation, offset, sortableProps, isDraggingOver }) => (
          <DeviationListItem
            key={`deviation-${deviation.deviationId}-item`}
            className={cn(isDraggingOver && s['hilite'])}
            sortableProps={sortableProps}
            offset={offset}
            deviation={deviation}
            selected={selectProps.selected}
            onSelect={selectProps.onSelect}
          />
        )}
      />
    </StudioDeviationListContext.Provider>
  );
};
DeviationList.displayName = 'DeviationList';

export default DeviationList;
